import { ExamReassignmentReadTaskPreview } from '@common/config/api/client'
import { East } from '@mui/icons-material'
import { Stack, TableBody, TableCell, TableRow, Typography, useTheme } from '@mui/material'

export default function ReassignExamTaskReadTableBody({ tasks }: { tasks: ExamReassignmentReadTaskPreview[] }) {
  const theme = useTheme()

  const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, ' ')
  }

  return (
    <TableBody>
      {tasks.map((task, index) => {
        const isLast = index === tasks.length - 1
        return (
          <TableRow key={index}>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Stack>
                <Typography color="text.primary" variant="body2">
                  {task.timepoint_pseudo_name}
                </Typography>
                <Typography color="text.secondary" variant="caption">
                  {`ID ${task.task_pseudo_id}`}
                </Typography>
              </Stack>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Typography color="text.primary" variant="body2">
                {formatStatus(task.from_status)}
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Stack>
                <East />
              </Stack>
            </TableCell>
            <TableCell
              sx={{
                borderBottom: isLast ? 'none' : `1px solid ${theme.palette.secondary.main}`,
              }}
            >
              <Typography color="text.primary" variant="body2">
                {task.to_status ? formatStatus(task.to_status) : '—'}
              </Typography>
            </TableCell>
          </TableRow>
        )
      })}
    </TableBody>
  )
}
